module.exports = __webpack_public_path__ + "img/magnifying-glass.876cc104.svg";